import {
    ArchiveRestore,
    ArrowLeft,
    ArrowLeftRight,
    BadgeCheck,
    BookType,
    Building2,
    Check,
    ChevronDown,
    ChevronLeft,
    ChevronRight,
    ChevronUp,
    CircleAlert,
    CircleCheck,
    CircleUserRound,
    CircleX,
    ClipboardList,
    Copy,
    Download,
    Dumbbell,
    Earth,
    FileCheck,
    FileText,
    Home,
    KeyRound,
    LogOut,
    MapPin,
    PanelLeftOpen,
    PanelRightOpen,
    PencilLine,
    Plus,
    RectangleEllipsis,
    RefreshCcw,
    RotateCcw,
    RotateCw,
    Save,
    Search,
    Settings,
    Sheet,
    SquareArrowOutUpRight,
    SquareArrowRightExit,
    Trash2,
    TriangleAlert,
    Trophy,
    User,
    Users,
    UserSearch,
    X,
} from 'lucide-angular';

export const lucideIcons = {
    ArchiveRestore,
    ArrowLeft,
    ArrowLeftRight,
    BadgeCheck,
    BookType,
    Building2,
    Check,
    ChevronLeft,
    ChevronRight,
    ChevronDown,
    ClipboardList,
    CircleUserRound,
    CircleX,
    CircleCheck,
    CircleAlert,
    Copy,
    Dumbbell,
    Download,
    Earth,
    FileCheck,
    FileText,
    Home,
    KeyRound,
    LogOut,
    MapPin,
    PanelLeftOpen,
    PanelRightOpen,
    PencilLine,
    Plus,
    RectangleEllipsis,
    RefreshCcw,
    RotateCw,
    RotateCcw,
    Search,
    Settings,
    Sheet,
    SquareArrowRightExit,
    SquareArrowOutUpRight,
    Trash2,
    TriangleAlert,
    Trophy,
    User,
    Users,
    UserSearch,
    X,
    Save,
    ChevronUp,
};
